// src/pages/calendar/Availability/index.js
// Import all components at the top of the file
import MyAvailability from "./AvailabilityPage";

// Import TeamAvailability as a named import with the correct path
import { TeamAvailability as TeamAvailabilityComponent } from "../TeamAvailability";

// Re-export all components
export { default as AvailabilityForm } from "./AvailabilityForm";
export { default as AvailabilityList } from "./AvailabilityList";
export { default as AvailabilityCards } from "./AvailabilityCards";
export { default as AvailabilityToolbar } from "./AvailabilityToolbar";
export { default as TimeSlotComponent } from "./TimeSlotComponent";
export { default as MonthView } from "./MonthView";

// Re-export the imported TeamAvailability with a clear name
export { TeamAvailabilityComponent as TeamAvailability };

// Re-export MyAvailability as a named export
export { MyAvailability };

// Also export MyAvailability as default
export default MyAvailability;
